import React, { useState } from "react";
import { novedades } from "../../components/Novedades/NovedadesData";
import NovedadCard from "../../components/Novedades/NovedadCard";
import "./Novedades.css";

const Novedades = () => {
  const [selectedId, setSelectedId] = useState(novedades[0]?.id || null);

  const selectedNovedad = novedades.find((n) => n.id === selectedId);
  const index = novedades.findIndex((n) => n.id === selectedId);

  const prev = index > 0 ? novedades[index - 1] : null;
  const next = index < novedades.length - 1 ? novedades[index + 1] : null;

  const handleConsulta = () => {
    window.open("https://wa.me/971585582100", "_blank");
  };

  return (
    <section className="novedades-container">
        <div className="novedades-text">

            <h2 className="novedades-title">Últimas novedades en Thorne Global</h2>
            <h3 className="novedades-subtitle">
                Descubrí nuestras últimas actividades, eventos exclusivos y avances estratégicos en el mercado inmobiliario internacional.
            </h3>
        </div>

        <NovedadCard
            data={selectedNovedad}
            onConsultaClick={handleConsulta}
            prev={prev}
            next={next}
            onSelect={(id) => setSelectedId(id)}
            novedadesList={novedades}
        />
    </section>
  );
};

export default Novedades;